import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "padding" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "测试页")
  ])
], -1)
const _hoisted_3 = { class: "content-main" }
const _hoisted_4 = { class: "padding" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Choose the button below to set the color of the selected range to green. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Try it out", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tip = _resolveComponent("tip")
  const _component_van_button = _resolveComponent("van-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_tip),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("login")), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("change")), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createVNode(_component_van_button, {
          onClick: $options.onSetColor,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Set color")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}